import React from 'react';
import PropTypes from 'prop-types';

import PlayerButton from '../PlayerButton';
import Switch from 'components/Switch';
import { isTouch } from 'util/device';

import styles from './PlayerHDAudio.styles';
import { injectStyles } from 'injectStyles';

const PlayerHDAudio = ({
  classes,
  isHDOn,
  currentStation,
  loadStation,
  setUserHDPreference,
  setPlaybackToLiveAudio,
}) => {
  if (isTouch) {
    return null;
  }

  if (!currentStation || !currentStation.tritonMountHD) {
    return null;
  }

  const handleAudioHD = () => {
    setPlaybackToLiveAudio();
    setUserHDPreference(!isHDOn);
    loadStation(currentStation);
  };

  const renderIcon = () => {
    return <Switch active={isHDOn} />;
  };

  const onPress = () => {
    handleAudioHD();
  };

  return (
    <div className={classes.playerHdAudio}>
      <PlayerButton
        data-testid="player-bottom-hdaudio-btn"
        onPress={onPress}
        active={isHDOn}
        title="HD Audio"
        renderIcon={renderIcon}
        hideOnMedium
      />
    </div>
  );
};

PlayerHDAudio.propTypes = {
  isHDOn: PropTypes.bool.isRequired,
  currentStation: PropTypes.object,
  loadStation: PropTypes.func.isRequired,
  setUserHDPreference: PropTypes.func.isRequired,
  setPlaybackToLiveAudio: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

PlayerHDAudio.defaultProps = {
  currentStation: null,
};

export default injectStyles(styles)(PlayerHDAudio);
